import React, { FC } from 'react';
import { Start, Stop } from './styles';

const Twitter: FC<SVGIconProps> = ({ linearGradient }) => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
    <path
      d="M26.6668 40.0002L40.5068 32.0002L26.6668 24.0002V40.0002ZM57.4935 19.1202C57.8402 20.3735 58.0802 22.0535 58.2402 24.1868C58.4268 26.3202 58.5068 28.1602 58.5068 29.7602L58.6668 32.0002C58.6668 37.8402 58.2402 42.1335 57.4935 44.8802C56.8268 47.2802 55.2802 48.8268 52.8802 49.4935C51.6268 49.8402 49.3335 50.0802 45.8135 50.2402C42.3468 50.4268 39.1735 50.5068 36.2402 50.5068L32.0002 50.6668C20.8268 50.6668 13.8668 50.2402 11.1202 49.4935C8.72016 48.8268 7.1735 47.2802 6.50683 44.8802C6.16016 43.6268 5.92016 41.9468 5.76016 39.8135C5.5735 37.6802 5.4935 35.8402 5.4935 34.2402L5.3335 32.0002C5.3335 26.1602 5.76016 21.8668 6.50683 19.1202C7.1735 16.7202 8.72016 15.1735 11.1202 14.5068C12.3735 14.1602 14.6668 13.9202 18.1868 13.7602C21.6535 13.5735 24.8268 13.4935 27.7602 13.4935L32.0002 13.3335C43.1735 13.3335 50.1335 13.7602 52.8802 14.5068C55.2802 15.1735 56.8268 16.7202 57.4935 19.1202Z"
      fill="url(#paint0_linear_173_163)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_173_163"
        x1="32.0002"
        y1="13.3335"
        x2="38.2087"
        y2="97.4745"
        gradientUnits="userSpaceOnUse"
      >
        <Start startColor={linearGradient?.startColor} />
        <Stop stopColor={linearGradient?.stopColor} offset="1" />
      </linearGradient>
    </defs>
  </svg>
);

export default Twitter;
